import { z } from 'zod';

export const testimonialSchema = z.object({
  id: z.number().optional(),
  name: z.string().min(1, 'Internal identifier is required'),
  author: z.string().min(1, 'Display name is required'),
  when: z.string().nullable().optional(),
  rating: z.number().int().min(1).max(5).nullable().optional(),
  claim_type: z.string().min(1, 'Claim type is required'),
  testimonial: z.string().min(1, 'Testimonial is required'),
  locale: z.string(),
  office_ids: z.array(z.number()),
});

export type TestimonialInput = z.infer<typeof testimonialSchema>;
